import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { HierarchyDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-hierarchy-container',
  templateUrl: './hierarchy-container.component.html',
  styleUrls: ['./hierarchy-container.component.scss']
})
export class HierarchyContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  hierarchys$: Observable<HierarchyDto[]>;
  loading: boolean;
  isLoadingHierarchy$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingHierarchy$ = this.gatwayFacade.isLoadingGateway(
      'Hierarchy'
    );
    this.hierarchys$ = this.gatwayFacade.loadGateway('Hierarchy');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteHierarchy(deletedValue: any) {
    this.gatwayFacade.remove('Hierarchy', deletedValue);
  }

  // this method control both the create and update

  onSubmitHierarchy(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Hierarchys;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllHierarchy = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllHierarchy.push(pullData[i]);
      }
    }

    // check if the addAllHierarchy array is not empty, then dispatch the data to the store
    if (addAllHierarchy.length > 0) {
      this.gatwayFacade.add('Hierarchy', addAllHierarchy);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('Hierarchy', allUpdates, ['id']);
    }
  }
}
